var _path, _path2, _circle, _circle2, _path3, _path4, _path5, _circle3, _path6, _rect, _path7, _rect2, _circle4, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _circle5, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeExpiredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 151,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.676 28.178c0-2.032 1.638-3.678 3.658-3.678H96.69c2.02 0 3.658 1.646 3.658 3.678 0 2.03-1.638 3.677-3.658 3.677H85.192c-2.02 0-3.659 1.647-3.659 3.678 0 2.031 1.638 3.678 3.659 3.678h26.655c2.598 0 4.704 2.117 4.704 4.728 0 2.612-2.106 4.728-4.704 4.728H29.791c-2.598 0-4.704-2.116-4.704-4.728 0-2.611 2.106-4.728 4.704-4.728h22.474c-.46 0-.901-.086-1.307-.242a3.679 3.679 0 0 0 2.352-3.436 3.678 3.678 0 0 0-2.352-3.436 3.636 3.636 0 0 1 1.307-.242h-9.93c-2.021 0-3.659-1.646-3.659-3.677ZM118.641 43.94c0-2.612 2.106-4.73 4.704-4.73h9.408c2.597 0 4.703 2.118 4.703 4.73 0 2.61-2.106 4.727-4.703 4.727h-9.408c-2.598 0-4.704-2.116-4.704-4.728ZM29.79 56.023c-2.597 0-4.703 2.117-4.703 4.728 0 2.612 2.106 4.729 4.704 4.729h64.286c2.597 0 4.704-2.117 4.704-4.729 0-2.611-2.107-4.728-4.704-4.728H29.79ZM5.226 76.775c0-2.176 1.755-3.94 3.92-3.94h31.882c2.165 0 3.92 1.764 3.92 3.94 0 2.177-1.755 3.94-3.92 3.94H39.46c-2.165 0-3.92 1.765-3.92 3.941s1.755 3.94 3.92 3.94h25.087c-2.165 0-3.92-1.764-3.92-3.94s1.755-3.94 3.92-3.94h59.059c2.165 0 3.92 1.764 3.92 3.94s-1.755 3.94-3.92 3.94h-10.714c-2.165 0-3.92 1.765-3.92 3.94 0 2.177 1.755 3.941 3.92 3.941h6.01c2.165 0 3.92 1.764 3.92 3.941 0 2.176-1.755 3.94-3.92 3.94H94.861c2.164 0 3.92 1.764 3.92 3.94s-1.756 3.941-3.92 3.941H64.024c-2.165 0-3.92 1.764-3.92 3.94s1.755 3.94 3.92 3.94h4.704c2.165 0 3.92 1.764 3.92 3.941 0 2.176-1.755 3.94-3.92 3.94H36.324c-2.165 0-3.92-1.764-3.92-3.94 0-2.177 1.755-3.941 3.92-3.941h.523c2.165 0 3.92-1.764 3.92-3.94s-1.755-3.94-3.92-3.94H3.92c-2.165 0-3.92-1.765-3.92-3.941s1.755-3.94 3.92-3.94H19.6c-2.166 0-3.92-1.764-3.92-3.94 0-2.177 1.754-3.94 3.92-3.94h.783c2.165 0 3.92-1.765 3.92-3.941s-1.755-3.94-3.92-3.94h-1.829c-2.165 0-3.92-1.765-3.92-3.94 0-2.177 1.755-3.941 3.92-3.941H9.146c-2.165 0-3.92-1.764-3.92-3.94ZM136.15 80.716c-2.165 0-3.92 1.764-3.92 3.94s1.755 3.94 3.92 3.94h9.93c2.165 0 3.92-1.764 3.92-3.94s-1.755-3.94-3.92-3.94h-9.93Z",
    fill: "#F6F8FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.509 113.815a3.144 3.144 0 0 0-3.136 3.152 3.144 3.144 0 0 0 3.136 3.152h6.794a3.144 3.144 0 0 0 3.136-3.152 3.144 3.144 0 0 0-3.136-3.152H92.51Z",
    fill: "#F6F8FC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.041,
    cy: 65.541,
    r: 2.041,
    fill: "#EEF2F5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.734,
    cy: 109.944,
    r: 2.041,
    fill: "#EEF2F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.618 103.882a.632.632 0 0 1 1.264 0v3.789a.632.632 0 0 1-1.264 0v-3.789ZM139.618 110.829a.632.632 0 0 1 1.264 0v3.789a.632.632 0 0 1-1.264 0v-3.789ZM145.618 108.618a.632.632 0 0 1 0 1.264h-3.789a.632.632 0 0 1 0-1.264h3.789ZM138.671 108.618a.632.632 0 0 1 0 1.264h-3.789a.632.632 0 0 1 0-1.264h3.789ZM25.594 125.911a.807.807 0 0 1 1.14 1.14l-3.418 3.417a.805.805 0 1 1-1.14-1.139l3.418-3.418ZM19.329 132.177a.805.805 0 1 1 1.139 1.139l-3.418 3.418a.805.805 0 1 1-1.14-1.139l3.419-3.418ZM26.734 135.595a.805.805 0 1 1-1.14 1.139l-3.417-3.418a.805.805 0 1 1 1.139-1.139l3.418 3.418ZM20.468 129.329a.805.805 0 1 1-1.14 1.139l-3.417-3.417a.806.806 0 0 1 1.14-1.14l3.417 3.418ZM23.21 27.46a.79.79 0 0 1 0 1.58h-4.736a.79.79 0 0 1 0-1.58h4.736ZM14.526 27.46a.79.79 0 0 1 0 1.58H9.79a.79.79 0 0 1 0-1.58h4.737ZM17.29 34.96a.79.79 0 1 1-1.58 0v-4.736a.79.79 0 0 1 1.58 0v4.737ZM17.29 26.276a.79.79 0 0 1-1.58 0V21.54a.79.79 0 1 1 1.58 0v4.736Z",
    fill: "#D2D9E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.25 11.75a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z",
    fill: "url(#a)",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.75 23.375a4.875 4.875 0 1 1-9.75 0 4.875 4.875 0 0 1 9.75 0Z",
    fill: "url(#b)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.625,
    cy: 123.875,
    r: 7.125,
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#62748A",
    d: "m101.352 41.297 8.631 7.795-3.897 4.315-8.631-7.794z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100.936,
    y: 33.083,
    width: 23.261,
    height: 5.815,
    rx: 2.908,
    transform: "rotate(42.084 100.936 33.083)",
    fill: "#A9BBC9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#62748A",
    d: "m48.346 41.296-8.632 7.795 3.898 4.315 8.631-7.794z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 23.261,
    height: 5.815,
    rx: 2.908,
    transform: "scale(-1 1) rotate(42.084 -67.38 -46.836)",
    fill: "#A9BBC9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.114,
    cy: 76.697,
    r: 38.788,
    fill: "url(#d)",
    stroke: "#A9BBC9",
    strokeWidth: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74.533,
    y: 44.713,
    width: 2.326,
    height: 5.815,
    rx: 1.163,
    fill: "#F17D83"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74.535,
    y: 102.865,
    width: 2.326,
    height: 5.815,
    rx: 1.163,
    fill: "#A9BBC9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 107.68,
    y: 75.534,
    width: 2.326,
    height: 5.815,
    rx: 1.163,
    transform: "rotate(90 107.68 75.534)",
    fill: "#A9BBC9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 49.527,
    y: 75.534,
    width: 2.326,
    height: 5.815,
    rx: 1.163,
    transform: "rotate(90 49.527 75.534)",
    fill: "#A9BBC9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 99.135,
    y: 98.49,
    width: 2.326,
    height: 5.815,
    rx: 1.163,
    transform: "rotate(135 99.135 98.49)",
    fill: "#A9BBC9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 58.016,
    y: 57.371,
    width: 2.326,
    height: 5.815,
    rx: 1.163,
    transform: "rotate(135 58.016 57.37)",
    fill: "#A9BBC9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 53.904,
    y: 100.135,
    width: 2.326,
    height: 5.815,
    rx: 1.163,
    transform: "rotate(-135 53.904 100.135)",
    fill: "#A9BBC9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 95.022,
    y: 59.016,
    width: 2.326,
    height: 5.815,
    rx: 1.163,
    transform: "rotate(-135 95.022 59.016)",
    fill: "#A9BBC9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 75.697,
    y: 76.115,
    width: 2.326,
    height: 25.342,
    rx: 1.163,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 77.406,
    y: 74.68,
    width: 3.37,
    height: 17.977,
    rx: 1.685,
    transform: "rotate(139.163 77.406 74.68)",
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.859,
    cy: 76.115,
    r: 4.652,
    fill: "#D0DCE6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.885 92.965c1.244-2.287 4.495-2.287 5.739 0l12.475 22.92c1.2 2.206-.379 4.905-2.87 4.905h-24.95c-2.49 0-4.07-2.699-2.869-4.905l12.475-22.92Z",
    fill: "url(#e)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.817 99.127a3.225 3.225 0 0 0-3.089 4.152l1.41 4.7.012.04c.051.171.099.332.178.473.201.357.544.612.943.702.158.035.326.035.505.034h.083c.178.001.347.001.504-.034.4-.09.743-.345.943-.702.079-.141.128-.302.179-.473l.012-.04 1.409-4.7a3.225 3.225 0 0 0-3.089-4.152ZM102.818 110.852a2.344 2.344 0 1 0-.001 4.689 2.344 2.344 0 0 0 .001-4.689Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 45.75,
    y1: 9.154,
    x2: 51.808,
    y2: 14.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 132,
    y1: 20,
    x2: 139.875,
    y2: 27.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 68.625,
    y1: 116.75,
    x2: 68.625,
    y2: 131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE3ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 33.826,
    y1: 40.914,
    x2: 116.402,
    y2: 122.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62748A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9BBC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 87,
    y1: 93.219,
    x2: 116.327,
    y2: 127.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeExpiredIcon);
export default __webpack_public_path__ + "static/media/time-expired-icon.68523be6bb9f8e4fbb498c77e7fdabbe.svg";
export { ForwardRef as ReactComponent };